module.exports = __webpack_public_path__ + "static/img/bb-top.afa36a8a.png";